(function () {
  if (!document.body.classList.contains("home-page")) {
    return;
  }

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduceMotion) {
    document.documentElement.classList.add("home-reveal-reduced");
    return;
  }

  const revealSelector = [
    ".product-clarity-heading > .eyebrow",
    ".product-clarity-heading > h2",
    ".product-clarity-visual",
    ".product-clarity-copy > p",
    ".product-clarity-grid > article",
    ".product-clarity-link",
    ".tablet-intro-copy > .eyebrow",
    ".tablet-intro-copy > h2",
    ".tablet-intro-copy > p",
    ".ritual-lifestyle-grid > article",
    ".tablet-intro-visual",
    ".ritual-steps-heading > .eyebrow",
    ".ritual-steps-heading > h2",
    ".ritual-steps-heading > p",
    ".ritual-step-list > article",
    ".homepage-confidence-heading > .eyebrow",
    ".homepage-confidence-heading > h2",
    ".homepage-confidence-heading > p",
    ".homepage-confidence-grid > article",
    ".shop-section .section-heading > .eyebrow",
    ".shop-section .section-heading > h2",
    ".shop-section .section-heading > p",
    ".filter-row",
    ".product-grid > *",
    ".brand-intro-section > div > .eyebrow",
    ".brand-intro-section > div > h2",
    ".brand-intro-copy > p",
    ".brand-intro-copy > .text-link",
    ".editorial-grid-section > .editorial-card",
    ".site-footer > *",
  ].join(",");

  const groups = Array.from(document.querySelectorAll(".section, .site-footer"));
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    },
    {
      root: null,
      rootMargin: "0px 0px -8% 0px",
      threshold: 0.14,
    },
  );

  function collectGroupItems(group) {
    return Array.from(group.querySelectorAll(revealSelector)).filter((element) => {
      if (element.dataset.homeReveal === "true") {
        return false;
      }

      if (element.closest(".cart-drawer")) {
        return false;
      }

      return element.offsetParent !== null;
    });
  }

  function setupRevealItems() {
    groups.forEach((group) => {
      const items = collectGroupItems(group).sort((a, b) => {
        const aTop = a.getBoundingClientRect().top + window.scrollY;
        const bTop = b.getBoundingClientRect().top + window.scrollY;

        if (Math.abs(aTop - bTop) > 8) {
          return aTop - bTop;
        }

        return 0;
      });

      items.forEach((element, index) => {
        const delay = Math.min(index * 82, 574);
        element.dataset.homeReveal = "true";
        element.style.setProperty("--home-reveal-delay", `${delay}ms`);

        observer.observe(element);
      });
    });
  }

  setupRevealItems();

  const mutationObserver = new MutationObserver(() => {
    window.requestAnimationFrame(setupRevealItems);
  });

  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
